import { LowerCasePipe, UpperCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	BadgeComponent,
	CardSelectComponent,
	CollapseComponent,
	DividerComponent,
	InfoGroupComponent,
	LinkComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { IOcrOperation, OPERATION_TYPE } from '../../../../../operations/models/operations.models';
import { ocrCaptureModeLabelKey } from '../../../../utils/workflow-ocr.util';
import { ModalOcrFraudScoringDetailsComponent } from '../modal-ocr-fraud-scoring-details/modal-ocr-fraud-scoring-details.component';
import { DeveloperCurlButtonComponent } from '../../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-ocr-operation',
	imports: [
		TranslatePipe,
		UpperCasePipe,
		LowerCasePipe,
		CollapseComponent,
		TileComponent,
		InfoGroupComponent,
		CardSelectComponent,
		DividerComponent,
		TagComponent,
		BadgeComponent,
		LinkComponent,
		DeveloperCurlButtonComponent,
		ModalOcrFraudScoringDetailsComponent,
	],
	templateUrl: './ocr-operation.component.html',
	styleUrl: './ocr-operation.component.scss',
})
export class OcrOperationComponent implements OnInit {
	@Input() operation?: IOcrOperation;
	@Input() index: number = 1;
	@Input() profileUuid?: string;

	public demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.CUSTOM';
	public showModalOcrFraudScoring = false;

	/** Label i18n del tipo de captura OCR (auto / manual / flexible). */
	public get ocrModeLabelKey(): string {
		return ocrCaptureModeLabelKey(this.operation?.config?.mode);
	}

	ngOnInit(): void {
		if (this.operation && this.operation.type !== OPERATION_TYPE.OCR) {
			this.operation = undefined;
		} else {
			this.updateDemandLevelLabel();
		}
	}

	public operationCurlPath(): string {
		if (!this.profileUuid || !this.operation?.uuid) return '';
		return `/profile/${this.profileUuid}/operations/${this.operation.uuid}`;
	}

	private updateDemandLevelLabel(): void {
		const photocopyBlocked = this.operation?.config?.fraud_scoring?.photocopy_check?.blocking_step;
		const photoBlocked = this.operation?.config?.fraud_scoring?.screen_photo?.blocking_step;
		const manipulatedImageBlocked = this.operation?.config?.fraud_scoring?.manipulated_photo?.blocking_step;
		const identifierBlocked = this.operation?.config?.fraud_scoring?.identifier_blocked?.blocking_step;
		const numTried = this.operation?.config?.setting?.total_tries === 2;
		const maxTimeSide = this.operation?.config?.setting?.side_max_time === 150;

		if (
			photocopyBlocked &&
			photoBlocked &&
			manipulatedImageBlocked &&
			identifierBlocked &&
			numTried &&
			maxTimeSide
		) {
			this.demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.RECOMMENDED';
		} else {
			this.demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.CUSTOM';
		}
	}

	public openFraudScoring(): void {
		this.showModalOcrFraudScoring = true;
	}

	public closeFraudScoring(): void {
		this.showModalOcrFraudScoring = false;
	}
}
